import { toastService } from '@thefarmersfront/kitchen';

import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { TOAST_MESSAGE } from '~/constants/common';

import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * 쿼리/뮤테이션 전역 에러 핸들러
 * - meta.silent: true 설정 시 토스트 표시 안함
 */
const handleError = (error: TypeErrorResponseData['error'], silent?: boolean) => {
  if (silent) return;

  toastService.addToast({
    type: 'error',
    message: error?.message || TOAST_MESSAGE.DEFAULT_ERROR,
  });
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => handleError(error, query.meta?.silent),
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => handleError(error, mutation.meta?.silent),
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5분
      gcTime: 1000 * 60 * 10, // 10분
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});
